import { z } from "zod"

// Example schema for the possible values of the 'period' field
const periodEnumSchema = z.enum([
  `ON_PEAK`,
  `PARTIAL_PEAK`,
  `OFF_PEAK`,
  `CRITICAL_PEAK`,
])

// Example schema for the possible values of the 'dataType' field
const dataTypeEnumSchema = z.enum([
  `string`,
  `choice`,
  `boolean`,
  `date`,
  `decimal`,
  `integer`,
  `formula`,
  `demand`,
])

// Example schema for the possible values of the 'propertyTypes' field
const propertyTypeEnumSchema = z.enum([
  `APPLICABILITY`,
  `RATE_CRITERIA`,
  `BENEFIT`,
  `DATA_REPUTATION`,
  `SERVICE_TERMS`,
])

// Definition of the TariffProperty schema
export const tariffPropertySchema = z.object({
  /** Unique name for this property */
  keyName: z.string().nonempty(),
  /** Type of time of use (optional) */
  period: periodEnumSchema.optional(),
  /** Display name of this property */
  displayName: z.string().nonempty(),
  /** Top-level categorization of the property hierarchy */
  keyspace: z.string().nonempty(),
  /** Second-level categorization of the property hierarchy, below keyspace */
  family: z.string().nonempty(),
  /** Longer description of the tariff property */
  description: z.string().nonempty(),
  /** Data type of this property */
  dataType: dataTypeEnumSchema,
  /** Category of property */
  propertyTypes: propertyTypeEnumSchema,
  /** Mathematical operator associated with this property's value (optional) */
  operator: z.string().optional(),
  /** Specific value of this property (optional) */
  propertyValue: z.string().optional(),
  /** Minimum value of this property (optional) */
  minValue: z.string().optional(),
  /** Maximum value of this property (optional) */
  maxValue: z.string().optional(),
  /** Possible choices for this array (optional) */
  choices: z.array(z.string()).optional(),
  /** Formula details if this property is a FORMULA type (optional) */
  formulaDetail: z.string().optional(),
  /** Whether the value of this Property is the default value (optional) */
  isDefault: z.boolean().optional(),
})

export type TariffProperty = z.infer<typeof tariffPropertySchema>
